import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=6f651ca4"
import script from "./Banner.ts?vue&type=script&lang=ts&external"
export * from "./Banner.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports